import * as React from "react";
import Svg, { Path } from "react-native-svg";

const SvgComponent = (props) => (
  <Svg
    {...props}
    width={20}
    height={20}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <Path
      d="M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0Z"
      fill="#00AB59"
    />
    <Path
      d="m8.24 13.756-2.996-2.997a.831.831 0 1 1 1.177-1.176l2.412 2.403 5.742-5.742a.831.831 0 1 1 1.177 1.177l-6.335 6.335a.831.831 0 0 1-1.177 0Z"
      fill="#fff"
    />
  </Svg>
);

export default SvgComponent;
